import { render, staticRenderFns } from "./shenzhenPrintModel.vue?vue&type=template&id=641ce4d7&scoped=true&"
import script from "./shenzhenPrintModel.vue?vue&type=script&lang=js&"
export * from "./shenzhenPrintModel.vue?vue&type=script&lang=js&"
import style0 from "./shenzhenPrintModel.vue?vue&type=style&index=0&id=641ce4d7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641ce4d7",
  null
  
)

export default component.exports